import { isEmptyObject } from "../../../utils/tests";
import { LmpMatchLineupsQuery } from '../types';

/**
 * typeguard for LmpMatchLineupsQuery
 * @param LmpMatchLineupsQuery object passed to transformer
 */
export const isValidLmpMatchLineups = (obj: LmpMatchLineupsQuery): boolean => Boolean(obj?.data?.lineups && !isEmptyObject(obj.data.lineups));
